export default __webpack_public_path__ + "static/media/hair-bright-winter.0178643e.png";